






















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import dayjs from "dayjs";
import { emptyToLine } from "@/utils/common";

@Component({})
export default class SettlementPrint extends Vue {
  @Prop({ default: () => {} })
  data: any;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  get $data() {
    return this.data;
  }
  get checkList() {
    return [
      {
        serviceName: this.$data.templateName,
        technicianName: this.$data.technicianName
      }
    ];
  }
}
